const siblings = (n) => [...n.parentElement.children].filter((c) => c != n);

const inertOtherElements = (node, elements = []) => {
	let processedSiblings = siblings(node).filter((sibling) => {
		if (["SCRIPT", "NOSCRIPT", "LINK"].includes(sibling.tagName)) return;
		sibling.setAttribute("inert", true);
		return sibling;
	});
	const cumulativeElements = [...elements, ...processedSiblings];
	if (node.parentElement.tagName !== "BODY") {
		return inertOtherElements(node.parentElement, cumulativeElements);
	} else {
		return cumulativeElements;
	}
};

window.inertOtherElements = inertOtherElements;
window.addEventListener("load", (event) => {
	const disclosures = document.querySelectorAll(".disclosure-has-popup");
	[...disclosures].forEach((disclosure) => {
		const close = () => {
			const drawer = disclosure.closest("facet-drawer");
			if (drawer) {
				drawer.closeMenuDrawer();
			} else {
				disclosure.removeAttribute("open");
			}
		};

		disclosure.addEventListener("focusout", (event) => {
			if (!event.relatedTarget) return;
			if (event.relatedTarget.tagName === "MAIN") return;
			if (disclosure.contains(event.relatedTarget)) return;
			close();
		});

		disclosure.addEventListener("keydown", (event) => {
			if (event.key === "Escape") {
				close();
				disclosure.querySelector("summary").focus();
			}
		});
	});

	const aftership = document.querySelectorAll(
		".automizely_personalization_recommendation_widget"
	);
	const aftershipConfig = { childList: true, subtree: true };

	// Callback function to execute when mutations are observed
	const aftershipCallback = (mutationList, observer) => {
		const elements = document.querySelectorAll(
			'.am_productInfo_container:not([role="link"])'
		);

		elements.forEach((element) => {
			element.setAttribute("role", "link");
			const target = element.closest("[data-apz-upsell-product-handle]");
			const dest = target.getAttribute("data-apz-upsell-product-handle");
			element.addEventListener("keydown", (event) => {
				if (event.key === "Enter") {
					window.location.href = `/products/${dest}`;
				}
			});
			const stars = element.querySelector(".widget_rec_stars");
			if (stars) {
				const count =
					5 - stars.querySelectorAll('[fill-rule="evenodd"]').length;
				const newEl = document.createElement("span");
				newEl.classList.add("visually-hidden");
				newEl.textContent = `${count} stars`;
				stars.appendChild(newEl);
			}
		});
	};

	aftership.forEach((widget) => {
		const observer = new MutationObserver(aftershipCallback);
		observer.observe(widget, aftershipConfig);
	});
});

class BackInStock extends HTMLElement {
	constructor() {
		super();

		this.COMPANY_ID = "QGWuEs";
		this.LIST_ID = "PYx8n2";
	}

	connectedCallback() {
		this.waitlist = this.querySelector("[data-waitlist]");
		this.variant = this.querySelector("[data-variant]");
		this.dialog = this.querySelector("[data-waitlist-dialog]");
		this.close = this.querySelectorAll("[data-close]");
		this.submit = this.querySelector("[data-submit]");
		this.form = this.querySelector("form");
		this.error = this.querySelector("[data-error]");
		this.success = this.querySelector("[data-success]");
		this.bindEventListeners();
  }

	bindEventListeners() {
		this.waitlist.addEventListener("click", () => {
			this.dialog.showModal();
		});

		this.dialog.addEventListener("click", (event) => {
			if (event.target === this.dialog) {
				this.closeDialog();
			}
		});

		this.close.forEach((close) => {
			close.addEventListener("click", () => {
				this.closeDialog();
			});
		});

		document.addEventListener("variant:change", (event) => {
			const { id, variant } = event.detail;
			if (this.variant.querySelector(`[value="${variant.id}"]`)) {
				this.variant.value = variant.id.toString();
			}
			if (id === this.dataset.productId) {
				if (variant.available === false) {
					this.waitlist.removeAttribute("hidden");
				} else {
					this.waitlist.setAttribute("hidden", "");
				}
			}
		});

		this.form.addEventListener("submit", this.submitForm.bind(this));
	}

	closeDialog() {
		this.dialog.close();
		this.error.style.display = "none";
		this.success.style.display = "none";
	}

	submitForm(event) {
		event.preventDefault();
		if (this.submit.hasAttribute("aria-disabled")) return;
		const formData = new FormData(this.form);
		const obj = Object.fromEntries(formData);
		this.submit.setAttribute("aria-disabled", true);

		Promise.all([
			this.submitBackInStockRequest(obj),
			this.submitSubscriptionRequest(obj),
		])
			.then((value) => {
				this.showSuccess();
			})
			.catch((error) => {
				console.error(error);
				this.showError();
			});
	}

	submitBackInStockRequest(form) {
		const body = JSON.stringify({
			data: {
				type: "back-in-stock-subscription",
				attributes: {
					profile: {
						data: {
							type: "profile",
							attributes: {
								email: form.email,
							},
						},
					},
					channels: ["EMAIL"],
				},
				relationships: {
					variant: {
						data: {
							type: "catalog-variant",
							id: `$shopify:::$default:::${form.variant}`,
						},
					},
				},
			},
		});

		return fetch(
			`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.COMPANY_ID}`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: `application/json`,
					Revision: "2024-02-15",
				},
				body,
			}
		)
			.then((response) => {
				if (response.ok) {
					return true;
				}
				throw new Error(response.status);
			})
			.catch((e) => {
				throw new Error(e);
			});
	}

	submitSubscriptionRequest(form) {
		if (!form.subscribe) {
			return Promise.resolve(true);
		}
		const body = JSON.stringify({
			data: {
				type: "subscription",
				attributes: {
					profile: {
						data: {
							type: "profile",
							attributes: {
								email: form.email,
							},
						},
					},
				},
				relationships: {
					list: {
						data: {
							type: "list",
							id: this.LIST_ID,
						},
					},
				},
			},
		});

		return fetch(
			`https://a.klaviyo.com/client/subscriptions/?company_id=${this.COMPANY_ID}`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: `application/json`,
					Revision: "2024-02-15",
				},
				body,
			}
		)
			.then((response) => {
				if (response.ok) {
					return true;
				}
				throw new Error(response.status);
			})
			.catch((e) => {
				throw new Error(e);
			});
	}

	showError() {
		this.submit.removeAttribute("aria-disabled");
		this.error.style.display = "block";
		setTimeout(() => this.error.focus(), 0);
	}

	showSuccess() {
		this.submit.removeAttribute("aria-disabled");
		this.success.style.display = "block";
		setTimeout(() => this.success.focus(), 0);
	}
}
window.addEventListener('DOMContentLoaded', function() {
	customElements.define("back-in-stock", BackInStock);
});